<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20.017" height="20.017" viewBox="0 0 20.017 20.017" v-bind="$attrs">
        <path d="M16.5,12A4.5,4.5,0,1,1,12,7.5,4.5,4.5,0,0,1,16.5,12Zm0,0c0,1.657,1.007,3,2.25,3S21,13.657,21,12a9,9,0,1,0-2.636,6.364M16.5,12V8.25" transform="translate(-1.983 -1.988)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </svg>
</template>
